import { OPEN_POI_LISTING_MENU, CLOSE_POI_LISTING_MENU, ENABLE_FLY_TO, DISABLE_FLY_TO } from '../actions/poiListingActions';

const initial_state = {
  open: false,
  flyTo: false
};

const poiListingMenuReducer = (state = initial_state, action) => {
  switch (action.type) {
    case OPEN_POI_LISTING_MENU: 
      return {open: true};
    case CLOSE_POI_LISTING_MENU:
      return {open: false};
    case ENABLE_FLY_TO: 
      return {flyTo: true};
    case DISABLE_FLY_TO:
      return {flyTo: false};
    default: 
      return state;
  }
}; 

export default poiListingMenuReducer;